module.exports = __webpack_public_path__ + "assets/img/travel-day12.948705f1.png";